import { useEffect, useContext } from "react";
import AuthContext from "../../store/AuthContext";
import { okErrorToast } from "../../utils/ToastUtil";

const useGeoLocation = () => {
  const authCtx = useContext(AuthContext);
  const { location, setLocation } = authCtx;

  useEffect(() => {
    if (!navigator.geolocation) {
      okErrorToast("Location", "Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;

        const isDifferent =
          location?.latitude !== latitude || location?.longitude !== longitude;

        if (isDifferent) {
          console.log("Previous location:", location);
          console.log("Updated location:", { latitude, longitude });
          setLocation(latitude, longitude);
        } else {
          console.log("Location unchanged:", location);
        }
      },
      (error) => {
        okErrorToast("Location", error.message);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  }, []);
};

export default useGeoLocation;
